import * as React from 'react';
import useDeeplink from './useDeeplink';
if (process.env.BROWSER) {
  require('./index.less');
}
export function DownloadButton({text}: {text: string}) {
  const deeplink = useDeeplink();
  if (!deeplink) {
    return <div className="deeplink-btn-container"></div>;
  }
  return (<div className="deeplink-btn-container">
    <div ref={deeplink.buttonRef} className="deeplink-download-btn" >{text}</div>
  </div>);
}
